import { analyticsTrack } from './analytics-track';
export interface IDigitalData {
  page: {
    pageInfo: IDigitalDataPageInfo;
  };
}
export interface IDigitalDataPageInfo {
  pageName: string;
  livello1: string;
  secondolivello: string;
  terzolivello: string;
  quartolivello: string;
  pagetemplate: string;
}

const setDigitalDataGallery = (newValues: { targetKey: keyof IDigitalDataPageInfo; value: string }[]) => {
  const pageInfo: IDigitalDataPageInfo = (window as any).digitalData ? (window as any).digitalData.page.pageInfo : {};
  newValues.forEach(({ targetKey, value }) => (pageInfo[targetKey] = value));
};

const trackElementInViewport = (element: Element, index: number) => {
  let hasLogged = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !hasLogged) {
        analyticsTrack('change_gallery', { hash: index });
        hasLogged = true;
        observer.disconnect();
      }
    });
  });
  observer.observe(element);
};


const updatePageTemplate = (pageName: string | undefined | null) => {
  if (pageName === 'pagelle') {
    setDigitalDataGallery([{ targetKey: 'pagetemplate', value: 'pagelle' }]);
  } else if (pageName === 'probabili-formazioni') {
    setDigitalDataGallery([{ targetKey: 'pagetemplate', value: 'probabili-formazioni' }]);
  }
};

export const trackPlayersCards = () => {
  const tabs = Array.from(
    document.querySelectorAll<HTMLInputElement>('.ftbl__team-tabs-wrapper__tab > input')
  );
  const teamsList = Array.from(document.querySelectorAll('.ftbl__football-team'));
  const pageName = document.querySelector('.ftbl__team-tabs-wrapper')?.getAttribute('data-team-type');

  updatePageTemplate(pageName);

  const trackVisibleTeam = (isPrimaryTab: boolean = true) => {
    const visibleTeamwrapper = teamsList.find((team) => window.getComputedStyle(team).display !== 'none');
    const visibleTeam = visibleTeamwrapper?.firstElementChild?.querySelectorAll('.ftbl__football-team__player-wrapper');

    visibleTeam &&
      visibleTeam.forEach((card, index) =>
        trackElementInViewport(card, isPrimaryTab ? index + 1 : visibleTeam.length + index + 1)
      );
  };

  tabs.forEach((tab: HTMLInputElement) => {
    if (!tab.checked) {
      const handleClick = () => {
        trackVisibleTeam(false);
        tab.removeEventListener('click', handleClick);
      };

      tab.addEventListener('click', handleClick);
    }
  });

  trackVisibleTeam();
};
